"use client";

import { Link } from "@/components/common/Link";
import { Instagram } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const quickLinks = [{
    title: "Inicio",
    to: "/HomePage"
  }, {
    title: "Nuestra Historia",
    to: "/OurHistoryPage"
  }, {
    title: "Nuestro Aceite",
    to: "/OurOilPage"
  }, {
    title: "Del Olivar a la Botella",
    to: "/OliveGroveToBottlePage"
  }, {
    title: "Catas en La Haya",
    to: "/HayaTastingPage"
  }, {
    title: "Para Tiendas",
    to: "/ForStoresPage"
  }];
  const legalLinks = [{
    title: "Política de Privacidad",
    to: "#"
  }, {
    title: "Política de Cookies",
    to: "#"
  }];
  return <section id="pie-de-página" className="bg-secondary text-foreground py-48">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <img src="https://wise-hagfish.10web.cloud/wp-content/uploads/2026/03/WhatsApp-Image-2026-01-16-at-09.53.22.jpeg" alt="Aceite Paco & Herminia" className="h-7 w-auto" />
            <p className="text-sm leading-relaxed opacity-90 max-w-xs font-sans">
              Tradición familiar, calidad premium y compromiso con la sostenibilidad en cada gota de nuestro aceite de oliva virgen extra.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif font-medium text-xl">Enlaces Rápidos</h3>
            <nav className="flex flex-col gap-3">
              {quickLinks.map((link, i) => <Link key={link.to} to={link.to} data-index={i} className="text-sm opacity-80 hover:opacity-100 transition-opacity font-sans">
                  {link.title}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif font-medium text-xl">Legal y Redes</h3>
            <div className="flex flex-col gap-3">
              {legalLinks.map((link, i) => <Link key={link.title} to={link.to} data-index={i} className="text-sm opacity-80 hover:opacity-100 transition-opacity font-sans">
                  {link.title}
                </Link>)}
            </div>
            <Link to="https://instagram.com" newTab className="inline-flex items-center gap-2 text-sm opacity-90 hover:opacity-100 transition-opacity mt-2 font-sans">
              <Instagram className="size-5 stroke-[1.5px]" />
              <span>Síguenos en Instagram</span>
            </Link>
          </div>
        </div>

        <Separator className="bg-foreground/10 mb-12" />

        <div className="text-center">
          <p className="text-sm opacity-60 font-sans">
            Aceite Paco & Herminia © 2024 — De nuestra familia a su mesa
          </p>
        </div>
      </div>
    </section>;
}